export default {
  path: "/moduleMain",
  meta: {
    title: "公共路由"
  },
  component: () => import("../views/moduleMain.vue"),
  children: [
    {
      path: "/home",
      meta: {
        title: "首页",
        menu: {
          opacity: true,
          opacityTop: 60
        }
      },
      component: () => import("../views/main/home.vue")
    },
    {
      path: "/academic_education",
      meta: {
        title: "学历教育"
      },
      component: () => import("../views/main/academicEducation.vue")
    },
    {
      path: "/online_registration",
      meta: {
        title: "网上报名"
      },
      component: () => import("../views/main/onlineRegistration.vue")
    },
    {
      path: "/recruit",
      meta: {
        title: "集团招聘"
      },
      component: () => import("../views/main/recruit.vue")
    },
    {
      path: "/yes_teacher/:id",
      meta: {
        title: "优秀同事"
      },
      component: () => import("../views/main/yesTeacher.vue")
    },
    {
      path: "/education",
      meta: {
        title: "学历业务"
      },
      component: () => import("../views/main/education.vue")
    },
    {
      path: "/student",
      meta: {
        title: "学生风采"
      },
      component: () => import("../views/main/student.vue")
    },
    {
      path: "/self_business",
      meta: {
        title: "自考业务"
      },
      component: () => import("../views/main/selfBusiness.vue")
    },
    {
      path: "/vocation",
      meta: {
        title: "职业教育"
      },
      component: () => import("../views/main/vocation.vue")
    },
    {
      path: "/feature",
      meta: {
        title: "教学特色"
      },
      component: () => import("../views/main/feature.vue")
    },
    {
      path: "/concact_us",
      meta: {
        title: "联系我们"
      },
      component: () => import("../views/main/concactUs.vue")
    },
    {
      path: "/about_us",
      meta: {
        title: "关于我们"
      },
      component: () => import("../views/main/aboutUs.vue")
    }
  ]
};
